import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09ec6948"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-flex tw-w-full tw-h-full tw-flex-col" }
const _hoisted_2 = { class: "tw-flex tw-justify-between tw-p-[30px] tw-items-center tw-max-h-[95px] tw-h-[95px]" }
const _hoisted_3 = {
  id: "chr-sheading-status",
  class: "tw-text-[#211F58] tw-text-[18px] tw-font-semibold"
}
const _hoisted_4 = {
  key: 0,
  class: "custom-global-skeleton tw-w-full tw-h-full"
}
const _hoisted_5 = {
  key: 1,
  class: "tw-flex tw-w-full tw-h-full tw-justify-center tw-pt-9"
}
const _hoisted_6 = {
  class: /*#__PURE__*/_normalizeClass(`tw-text-[18px] content`)
}
const _hoisted_7 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass(`plus__minus`)
}

import { getComponentUiText } from "@/utils/utilities";

export default /*#__PURE__*/_defineComponent({
  __name: 'currentHealthStatus',
  props: {
  color: {
    type: String,
    default: "",
  },
  backcroundColor: {
    type: String,
    default: "",
  },
  status: {
    type: String,
    default: "",
  },
  text: {
    type: String,
    default: "",
  },
  loading: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(getComponentUiText)("app-manage-orgs-header-status-1")), 1),
      _createElementVNode("div", {
        style: _normalizeStyle(`border-radius: 7.566px; color: ${__props.color}; background-color: ${__props.backcroundColor};`),
        class: _normalizeClass(`content__status tw-bg-[${__props.backcroundColor}] tw-px-[10px] tw-pt-[12px] tw-pb-[10px] tw-font-medium tw-text-[${__props.color}]`)
      }, _toDisplayString(__props.status), 7)
    ]),
    (__props.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", {
            class: "wrapper",
            style: _normalizeStyle(`color: ${__props.color};`)
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createTextVNode(_toDisplayString(__props.text[0]) + " ", 1),
              (__props.text.length === 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(__props.text[1]), 1))
                : _createCommentVNode("", true)
            ])
          ], 4)
        ]))
  ]))
}
}

})